if (!customElements.get('tracking-viewed-products')) {
  customElements.define(
    'tracking-viewed-products',
    class TrackingViewedProducts extends HTMLElement {
      constructor() {
        super();
        this.expiresDate = parseInt(this.dataset.expiresDate) || 30;
        this.delay = parseInt(this.dataset.delaySeconds) || 0;
      }

      connectedCallback() {
        this.recordTimeout = setTimeout(() => {
          this.recordList({
            name: 'shopify_recently_viewed_products',
            expire: this.expiresDate,
            max: 10
          });
        }, this.delay * 1000);
      }

      disconnectedCallback() {
        if (this.recordTimeout) clearTimeout(this.recordTimeout);
      }

      setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
      }

      getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }

        return '';
      }

      deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
    
      getList(name) {
        let list = [],
        data = this.getCookie(name);
        if (data !== null && data !== undefined && data !== '') list = data.split(' ');
        return list;
      }
    
      setList(params, list) {
        if (this.dataset.productId !== '') {
          let productId = this.dataset.productId,
            position = list.indexOf(productId);
          if (position === -1) {
            list.unshift(productId);
            list = list.splice(0, params.max);
          } else {
            list.splice(position, 1);
            list.unshift(productId);
          }
          this.setCookie(params.name, list.join(' '), params.expire);
        }
      }

      removeList(params){
        this.setCookie(params.name, null, params.expire);
      }
    
      recordList(params) {    
        this.setList(params, this.getList(params.name));
      }
    }
  );
}